import { PagePreloaderComponent } from '../../shared/ui/page-preloader/page-preloader.component';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { TopLevelComponent } from '../../shared/models';
import { Store, StoreHelper, UserService } from '../../shared/services';
import { EmployeeScoreDetails } from '../shared';
import { EmployeesService } from '../shared/services';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'score-invoices',
    styles: [ require('./score-invoices.component.scss') ],
    template: require('./score-invoices.component.pug')
})
export class ScoreInvoicesComponent implements OnInit, OnDestroy {
    @ViewChild(PagePreloaderComponent) preloader;

    scoreDetails = new EmployeeScoreDetails(null);

    private _invoicesSubs: Subscription;

    constructor(
        private _employeesService: EmployeesService,
        store: Store) {

        let that = this;
        let storeState = store.getState();

        this._invoicesSubs = this._employeesService.getInvoices(storeState.employeeInvoicesFilter)
            .subscribe(res => {
                that.scoreDetails = res;
                that.preloader.hide();
            });
    }

    ngOnInit() {
        this.preloader.show();
    }

    ngOnDestroy() {
        this._invoicesSubs.unsubscribe();
    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/employees/scores/score-invoices.component.ts